import React from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import { PiCaretDoubleRightThin } from "react-icons/pi";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const projectsData = [
  {
    id: "ace-acreville",
    image: "/ACE ACREVILLE.webp",
    title: "ACE ACREVILLE",
    location: "Sector 22A, Yamuna Expressway",
    category: "Plots",
  },
  {
    id: "migsun-alpha-central",
    image: "/migsun.webp",
    title: "MIGSUN ALPHA CENTRAL",
    location: "Alpha 2, Greater Noida",
    category: "Commercial",
  },
  {
    id: "nx-one",
    image: "/NX ONE.webp",
    title: "NX ONE",
    location: "Greater Noida",
    category: "Township",
  },
  {
    id: "prateek-canary-sector-150",
    image: "/prateekcanary.webp",
    title: "PRATEEK CANARY",
    location: "Sector 150, Noida",
    category: "Residential",
  },
];

const HomeProjects = () => {
   const navigate = useNavigate();
  return (
    <div className="backdiv1">
      <h2 className="sapt-head text-center">RECENT PROJECTS</h2>
 <div className="project-swiper-wrapper">

        {/* Navigation Buttons */}
        <div className="swiper-btn swiper-btn-left">
          <FaChevronLeft />
        </div>
        <div className="swiper-btn swiper-btn-right">
          <FaChevronRight />
        </div>

      <Swiper
        modules={[Autoplay, Navigation]}
        spaceBetween={30}
        slidesPerView={1}
        loop
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
           navigation={{
            prevEl: ".swiper-btn-left",
            nextEl: ".swiper-btn-right",
          }}
        breakpoints={{
           480: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 1,
          },
           992: {
            slidesPerView: 1,
          },
          1024: {
            slidesPerView: 2,
          },
        }}
      >
        {projectsData.map((item) => (
          <SwiperSlide key={item.id}>
            <div className="home-project-card">
              <div className="image-wrapper">
                <img
                  className="img-cover"
                  src={item.image}
                  alt={item.title}
                  loading="lazy"
                />

                <div className="home-project-content">
                  <div className="content-inner">
                    <h3 className="proj-title">{item.title}</h3>
                    <p className="proj-location">{item.location}</p>
                    <div className="price-row">
                      <span className="price">{item.category}</span>
                      <button   onClick={() => navigate(`/projects/${item.id}`)} className="details-btn">Details</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      </div>
 <a href="/project"> 
   <div className='d-flex align-items-center justify-content-center'>
   <button className='svpl-btnss'>READ MORE<PiCaretDoubleRightThin /></button>
     </div>
     </a>
    </div>
  );
};

export default HomeProjects;
